export default __webpack_public_path__ + "static/gradient-d31a70cd2cf0e6525b5200bf8ca7fb8d.svg";